import { render, staticRenderFns } from "./EDialogProductPurchaseComp.vue?vue&type=template&id=a0511e5e&"
import script from "./EDialogProductPurchaseComp.vue?vue&type=script&lang=js&"
export * from "./EDialogProductPurchaseComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports